import React from 'react';
import THCell from './THCell';

export default ({ cols = [], children, ...rest }) => (
  <thead {...rest}>
    {cols.length > 0 && <tr>{cols.map(THCell)}</tr>}
    {children}
  </thead>
);
